import { useEffect, useState, useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import { getUsersWithUserName, updateLoginAttempts } from "../../services/adminPanel_service";
import { toast } from "react-toastify";

const LockUsersModal = ({ show, onClose, onDataReload }) => {

  const [availableUsers, setAvailableUsers] = useState([]);
  const [selectedUsersToLock, setSelectedUsersToLock] = useState([]);
  const [selectedUserRowForLock, setSelectedUserRowForLock] = useState(null);
  const [selectedUserRowForUnlock, setSelectedUserRowForUnlock] = useState(null);
  const [lockReason, setLockReason] = useState("");
  const [userSearchString, setUserSearchString] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  const searchTimeout = useRef(null);

  useEffect(() => {
    if (!userSearchString) {
      setAvailableUsers([]);
      return;
    }

    clearTimeout(searchTimeout.current);

    searchTimeout.current = setTimeout(() => {
      handleUserSearch();
    }, 400);

    return () => clearTimeout(searchTimeout.current);
  }, [userSearchString]);

  if (!show) return null;

  const columnDefs = [
    { headerName: "User Name", field: "userName", filter: true },
    { headerName: "Email", field: "emailAddress", filter: true }
  ];

  /* ---------------- USER SEARCH ---------------- */

  

  const handleUserSearch = async () => {
    try {
      const response = await getUsersWithUserName(userSearchString);
      setAvailableUsers(response?.data || []);
    } catch {
      setAvailableUsers([]);
    }
  };

  /* ---------------- LOCK USERS ---------------- */

  const handleLockUsers = async () => {

    if (isSaving) return;

    if (selectedUsersToLock.length === 0) {
      toast.error("Select at least one user to lock");
      return;
    }

    if (!lockReason) {
      toast.error("Please Specify the lock reason");
      return;
    }

    try {

      setIsSaving(true);

      const requests = selectedUsersToLock.map(user => {

        const payload = {
          UserId: user.userId,
          IsUser: [1,2].includes(Number(user.roleId)) ? 2 : 1,
          LockedType: 4,
          LockReason: lockReason
        };

        return updateLoginAttempts(payload);
      });

      const results = await Promise.allSettled(requests);

      const failed = results.filter(r => r.status === "rejected");

      if (failed.length === 0) {
        toast.success("Selected users locked successfully");
      } else {
        toast.warn(`${failed.length} users failed to lock`);
      }

      await handleUserSearch();

      setSelectedUsersToLock([]);
      setLockReason("");

      onDataReload();

    } catch {
      toast.error("Unable to lock selected users");
    } finally {
      setIsSaving(false);
    }
  };

  /* ---------------- ADD USER ---------------- */

  const handleAddUsersToLock = (user) => {

    if (!user) {
      toast.error("Select a user to add to lock list");
      return;
    }

    const exists = selectedUsersToLock.some(u => u.userId === user.userId);

    if (exists) {
      toast.warn("User already added for locking");
      return;
    }

    setSelectedUsersToLock(prev => [...prev, user]);
    setSelectedUserRowForLock(null);
  };

  /* ---------------- REMOVE USER ---------------- */

  const handleRemoveUsersFromLock = (user) => {

    if (!user) {
      toast.error("Select a user to remove from lock list");
      return;
    }

    setSelectedUsersToLock(prev =>
      prev.filter(item => item.userId !== user.userId)
    );

    setSelectedUserRowForUnlock(null);
  };

  return (
    <>
      <div className="modal fade in" style={{ display: "block" }}>
        <div className="modal-dialog" style={{ width: "55%" }}>
          <div className="modal-content">

            <div className="modal-header" style={{ padding: "0px 0px" }}>
              <button className="close" onClick={onClose}>
                &times;
              </button>
              <h4 className="modal-title" style={{ margin: 0 }}>Lock User</h4>
            </div>

            <div className="modal-body">

              <div className="form-group">

                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'start' }}>
                  <div className="col-sm-6" style={{ marginBottom: "15px" }}>

                    <label style={{ fontWeight: "bold", marginRight: "10px" }}>
                      User
                    </label>

                    <input
                      className="search-New-box"
                      type="search"
                      placeholder="Search"
                      value={userSearchString}
                      onChange={(e) => setUserSearchString(e.target.value)}
                      style={{ width: "200px" }}
                    />

                    <span
                      className="glyphicon glyphicon-search"
                      style={{ marginLeft: "5px" }}
                    />

                  </div>
                </div>

                <div className="row">

                  <div className="col-sm-5">
                    <div className="ag-theme-alpine" style={{ height: "201px" }}>
                      <AgGridReact
                        theme={'legacy'}
                        rowData={availableUsers}
                        columnDefs={columnDefs}
                        onRowClicked={(params) => setSelectedUserRowForLock(params.data)}
                        onRowDoubleClicked={(params) => handleAddUsersToLock(params.data)}
                        rowSelection="single"
                      />
                    </div>
                  </div>

                  <div
                    className="col-sm-2"
                    style={{ textAlign: "center", paddingTop: "70px" }}
                  >

                    <button
                      className="btn btn-primary"
                      style={{ width: "76px", marginBottom: "10px" }}
                      onClick={() => handleAddUsersToLock(selectedUserRowForLock)}
                    >
                      Add
                    </button>

                    <br />

                    <button
                      className="btn btn-primary"
                      style={{ width: "76px" }}
                      onClick={() => handleRemoveUsersFromLock(selectedUserRowForUnlock)}
                    >
                      Remove
                    </button>

                  </div>

                  <div
                    className="col-sm-5 generic-kendoGrid-custom"
                    style={{ paddingLeft: "20px" }}
                  >

                    <div className="ag-theme-alpine" style={{ height: "201px" }}>
                      <AgGridReact
                        theme={'legacy'}
                        rowData={selectedUsersToLock}
                        columnDefs={columnDefs}
                        onRowClicked={(params) => setSelectedUserRowForUnlock(params.data)}
                        onRowDoubleClicked={(params) => handleRemoveUsersFromLock(params.data)}
                        rowSelection="single"
                      />
                    </div>

                  </div>

                </div>

                <div className="row" style={{ marginTop: "20px" }}>
                  <div className="col-sm-5">

                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'start' }}>
                      <label style={{ fontWeight: "bold" }}>
                        Lock Reason
                      </label>
                    </div>

                    <input
                      type="text"
                      className="form-control"
                      value={lockReason}
                      onChange={(e) => setLockReason(e.target.value)}
                      style={{ width: "200px" }}
                    />

                  </div>
                </div>

              </div>

            </div>

            <div className="modal-footer">

              <button
                className="btn btn-primary"
                onClick={handleLockUsers}
                disabled={isSaving}
              >
                Save
              </button>

              <button
                className="btn btn-default"
                onClick={onClose}
              >
                Cancel
              </button>

            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default LockUsersModal;